// export var iswebapi = 'http://localhost:8080/imagesmartlite/#/view_report?';
// export var viewer_base_path = 'http://localhost:8080/imagesmartviewer/open_study.html?';
// export var usersign = 'http://localhost:8080/patientimage/';
// // export var webapi = 'http://localhost:8093/';
// // export var webapi = 'http://103.93.240.138:8080/dhanashri_beta_ws/';
// export var keyimage = 'http://localhost:8080/';
// export var viewpatientimage = 'http://localhost:8080/patientimage/';
// export var viewstaffsignature = 'http://localhost:8080/patientimage/';
// export var vc = 'https://medify.net/CBHI';
// export var viewpatientfiles = 'http://localhost:8080/patientimage/';

export var medify = 'https://stageservices.medify.net/';
export var IP = '192.168.1.3';
//
//show/hide console log true: hide logs and error and false: show logs
export var ShowHideConLog = false;

// medify
// var urlmainvalue = "http://202.140.139.84:8080";
// export var webapi = urlmainvalue + '/';

// var urlmainvalue1 = "http://3.108.22.254:8090";
// var urlmainvalue = "http://3.108.22.254:8090";

// var urlmainvalue1 = "http://localhost:8093";
// var urlmainvalue = "http://localhost:8093";

var urlmainvalue1 = "http://202.140.139.84:8080";
var urlmainvalue = "http://202.140.139.84:8080";

// var urlmainvalue1 = "http://vcnr-hospitals.medify.net:8082";
// var urlmainvalue = "http://vcnr-hospitals.medify.net:8080";
export var webapi = urlmainvalue + '/';



export var iswebapi = urlmainvalue + '/imagesmartlite/#/view_report?';
export var viewer_base_path = urlmainvalue + '/imagesmartviewer/open_study.html?';
export var usersign = urlmainvalue1 + '/';
export var keyimage = urlmainvalue + '/';

export var viewpatientimage = urlmainvalue1 + '/';
export var viewstaffsignature = urlmainvalue1 + '/';
export var vc = 'https://stageapi.medify.net/HIMS';
export var viewpatientfiles = urlmainvalue1 + '/';

export var Iran = false;
export var pharmacybillcheck = false;
export var isBillReqiredForDischarge = false;
export var isModifyBill = false;
export var Tawau = false;
export var MataPita = false;
export var SSPM = false;
export var COVID = false;
export var Shatabdi = false;
export var Shatabdi2 = true;
export var Tata = false;
export var Iilds = false;
export var Nepal = false;
export var Aarogyam = false;
export var Turkish = false;
export var Medikal = false;
export var W2H = false;
export var NMMC = false;
export var MK = false;
export var Karad = false;
export var GrandPort = false;
export var YCM = true;
export var Yogita = false;
export var ssnj = false;
export var swaraj = false;
export var vishvateja = false;
export var hind = false;
export var Nigeria = false;
export var Medify = true;

//configuration hospital wise
export var CONSTMALLIKAHOSPITAL = false;
export var CONSTSHIVAMHOSPITAL = false;
export var CONSTKUMARHOSPITAL = false;
export var CONSTMYDOCHOSPITAL = false;
export var CONSTQUESTWELLHOSPITAL = true;
export var CONSTVCNRHOSPITAL = false;
export var CONSTMEDIFYHUB = false;

export var historyId = 1;
export var fingerprinturl = 'http://localhost:8080/WebService/service/scanImage';
export var fingerprintimg = 'http://localhost:8080/fingure_images/';




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/shared/my-constants.ts